import styled from "styled-components";
import { FlexRow } from "../../../components/containers/styled";

export const FlexClaimRow = styled(FlexRow)`
    display: flex;
    justify-content: start;
    flex-direction: row;
    padding: 10px;
    border-bottom: 1px solid;
`

export const ClaimsHeader = styled.label`
    margin: 10px;
    width: 100%; 
    text-align: center;
`